import { Typography, styled } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { type FC } from 'react';
import { ControlledTextInput } from '../../../components/ControlledTextInput';
import type { AnrokRegisterFormControl } from '../AnrokRegisterFormSchema';
import { CREDENTIALS_LINK } from './register-to-anrok-components-consts';

interface Props {
  control: AnrokRegisterFormControl;
}

export const AnrokRegistration: FC<Props> = ({ control }) => {
  const handleCredentialsLinkClick = () => window.open(CREDENTIALS_LINK);

  return (
    <FormContainer>
      <LogoContainer>
        <VyIcon
          icon="AnrokIcon"
          style={{
            transform: 'scale(0.38)',
            transformOrigin: 'top left',
          }}
        />
      </LogoContainer>
      <Typography variant="h4">Enter your Anrok Credentials to get started</Typography>
      <ControlledTextInput
        name="apiKey"
        control={control}
        label="API Key"
        placeholder="Enter API Key here..."
        defaultValue=""
      />
      <Typography
        variant="subtitle2"
        sx={{ color: '#3A78F8', cursor: 'pointer' }}
        onClick={handleCredentialsLinkClick}
      >
        Where can I find my credentials?
      </Typography>
      <ControlledTextInput
        name="defaultExternalProductId"
        control={control}
        label="Default External Product ID"
        placeholder="Enter Default External Product ID here..."
        defaultValue=""
      />
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const LogoContainer = styled('div')({
  width: 132,
  height: 132,
});
